"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var moment = require("moment");
var dateTimePicker_1 = require("../dateTimePicker");
var checkbox_1 = require("../checkbox");
var DateTimeRangePicker = /** @class */ (function (_super) {
    tslib_1.__extends(DateTimeRangePicker, _super);
    function DateTimeRangePicker(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onAllDayChange = function (e) {
            var onChange = _this.props.onChange;
            _this.setState({
                allDay: e.target.checked
            }, function () {
                onChange(_this.props.fromDate.clone().startOf("day"), _this.props.fromDate.clone().startOf("day").add(1, "day"));
            });
        };
        _this.onFromChange = function (date) {
            var _a = _this.props, onFromChange = _a.onFromChange, toDate = _a.toDate;
            onFromChange && onFromChange(date);
            _this.onChange(date, toDate);
        };
        _this.onToChange = function (date) {
            var _a = _this.props, onToChange = _a.onToChange, fromDate = _a.fromDate;
            onToChange && onToChange(date);
            _this.onChange(fromDate, date);
        };
        _this.state = { allDay: props.allDay };
        return _this;
    }
    DateTimeRangePicker.prototype.onChange = function (from, to) {
        var onChange = this.props.onChange;
        onChange && onChange(from, to);
    };
    DateTimeRangePicker.prototype.render = function () {
        var _a = this.props, theme = _a.theme, className = _a.className, fromLabel = _a.fromLabel, toLabel = _a.toLabel, dateFormat = _a.dateFormat, fromDate = _a.fromDate, toDate = _a.toDate, allDay = _a.allDay, minFromDate = _a.minFromDate, maxFromDate = _a.maxFromDate, minToDate = _a.minToDate, maxToDate = _a.maxToDate, onChange = _a.onChange, onFromChange = _a.onFromChange, onToChange = _a.onToChange, enableAllDay = _a.enableAllDay, fromPickerProps = _a.fromPickerProps, toPickerProps = _a.toPickerProps, disabled = _a.disabled, others = tslib_1.__rest(_a, ["theme", "className", "fromLabel", "toLabel", "dateFormat", "fromDate", "toDate", "allDay", "minFromDate", "maxFromDate", "minToDate", "maxToDate", "onChange", "onFromChange", "onToChange", "enableAllDay", "fromPickerProps", "toPickerProps", "disabled"]);
        var classes = classnames_1.default(theme["date-time-range-picker"], className);
        return (React.createElement("div", { className: classes },
            React.createElement(dateTimePicker_1.DateTimePicker, tslib_1.__assign({ className: theme.from, label: fromLabel, dateFormat: dateFormat, date: fromDate, minDate: minFromDate, maxDate: maxFromDate, disabled: disabled, onChange: this.onFromChange, dateOnly: this.state.allDay }, fromPickerProps)),
            React.createElement(dateTimePicker_1.DateTimePicker, tslib_1.__assign({ className: theme.to, label: toLabel, dateFormat: dateFormat, date: toDate, minDate: minToDate, maxDate: maxToDate, disabled: disabled, onChange: this.onToChange, dateOnly: this.state.allDay }, toPickerProps)),
            enableAllDay ? (React.createElement(checkbox_1.Checkbox, { disabled: disabled, className: theme["all-day-checkbox"], label: "All Day", defaultChecked: this.state.allDay, onChange: this.onAllDayChange })) : null));
    };
    DateTimeRangePicker.defaultProps = {
        fromLabel: "From",
        toLabel: "To",
        allDay: false,
        enableAllDay: true,
        fromDate: moment(),
        toDate: moment().add(1, "month"),
        fromPickerProps: {},
        toPickerProps: {}
    };
    return DateTimeRangePicker;
}(React.Component));
exports.default = DateTimeRangePicker;
